// extracted by mini-css-extract-plugin
module.exports = {"pagination":"urr5c","paginationLink":"_3uA37"};